import React from 'react';
import { X } from 'lucide-react';

/**
 * Summary chip row shown under a filter panel when one or more multi-select
 * filters are active, e.g. "[2 Categories x] [3 Users x]" + Clear All.
 * `chips`: [{ key, label, onRemove }]
 */
export const ActiveFilterChips = ({ chips = [], onClearAll }) => {
  if (!chips.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 pt-3" data-testid="active-filter-chips">
      {chips.map((chip) => (
        <span
          key={chip.key}
          className="inline-flex items-center gap-1.5 pl-2.5 pr-1.5 py-1 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 text-xs font-medium"
          data-testid={`filter-chip-${chip.key}`}
        >
          {chip.label}
          <button
            type="button"
            onClick={chip.onRemove}
            className="h-4 w-4 flex items-center justify-center rounded-full hover:bg-indigo-200 transition-colors"
            data-testid={`filter-chip-remove-${chip.key}`}
            aria-label={`Remove ${chip.label} filter`}
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      {onClearAll && (
        <button
          type="button"
          onClick={onClearAll}
          className="text-xs font-medium text-slate-500 hover:text-red-600 underline ml-1"
          data-testid="clear-all-filters-chip-btn"
        >
          Clear All
        </button>
      )}
    </div>
  );
};

export default ActiveFilterChips;
